
import React from "react";
import HeaderLogo  from "../structure/headerlogo";
import CommonIcon from '../common/customicon';


const ContractComparison = () => (<div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
  <div className="bg-gray-50 min-h-screen">
    <div className=" ">
      <div className="flex items-center justify-between mb-6">
        {/* <div>
          <h1 className="text-3xl font-bold text-gray-900">Contract Comparison</h1>
          <p className="text-gray-500 mt-1">Compare terms across licensees for the same IP — identify inconsistencies</p>
        </div> */}

        <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="Scale" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                <h1 className="h3 mb-0 fw-bold">Contract Comparison</h1>
                <p className="text-muted mb-0 small">Compare terms across licensees for the same IP — identify inconsistencies</p>
              </div>
</div>  
        <div className="flex gap-2">
          <select className="border rounded-lg px-4 py-2 bg-white">
            <option>Aurora Animation</option>
            <option>Midnight Echo</option>
            <option>StarBlaze Heroes</option>
          </select>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg">Export Comparison</button>
        </div>
      </div>

      {/* AI Insights */}
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-1 mb-6">
        <div className="flex items-start gap-3">
          <span className="text-2xl" role="img" aria-label="ai">🧴</span>
          <div>
            <p className="font-semibold text-blue-800">AI Analysis Summary</p>
            <ul className="text-sm text-blue-700 mt-1 space-y-1">
              <li>• NovaTech Games has a significantly higher royalty rate (15%) compared to average (8.5%) — consider standardizing</li>
              <li>• Summit Ridge has the most favorable territory terms with exclusivity — other licensees are non-exclusive</li>
              <li>• Minimum guarantees vary widely ($25K-$100K) with no clear correlation to territory size</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Comparison Table */}
      <div className="bg-white rounded-xl shadow p-6 mb-6 overflow-x-auto">
        <h5 className="text-lg font-semibold mb-4">Side-by-Side Clause Comparison — Aurora Animation Licensees</h5>
        <table className="w-full text-sm min-w-[900px]">
          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 text-left min-w-[160px] sticky left-0 bg-gray-50">Clause</th>
              <th className="p-3 text-left min-w-[200px]">Summit Ridge Merch</th>
              <th className="p-3 text-left min-w-[200px]">Golden State Apparel</th>
              <th className="p-3 text-left min-w-[200px]">Bright Star Retail</th>
              <th className="p-3 text-left min-w-[200px]">NovaTech Games</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Royalty Rate</td>
              <td className="p-3">8%</td>
              <td className="p-3">7%</td>
              <td className="p-3">8%</td>
              <td className="p-3 bg-yellow-50"><span className="text-yellow-700 font-semibold">15%</span> <span title="Flagged by AI">⚠️</span></td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Minimum Guarantee</td>
              <td className="p-3">$30,000/yr</td>
              <td className="p-3 bg-yellow-50"><span className="text-yellow-700 font-semibold">$100,000/yr</span> <span title="Flagged by AI">⚠️</span></td>
              <td className="p-3">$60,000/yr</td>
              <td className="p-3">$25,000/yr</td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Territory</td>
              <td className="p-3 bg-green-50"><span className="text-green-700">US (Exclusive)</span></td>
              <td className="p-3">US (Non-exclusive)</td>
              <td className="p-3">EU + UK (Non-exclusive)</td>
              <td className="p-3">North America (Non-exclusive)</td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Term</td>
              <td className="p-3">3 years</td>
              <td className="p-3">2 years</td>
              <td className="p-3 bg-red-50"><span className="text-red-700">1 year</span></td>
              <td className="p-3">2 years</td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Product Categories</td>
              <td className="p-3">Apparel, Toys, Stationery, Accessories</td>
              <td className="p-3">Apparel only</td>
              <td className="p-3">Apparel, Home Decor</td>
              <td className="p-3">Digital, Games</td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">QC Approval</td>
              <td className="p-3">30 days</td>
              <td className="p-3">30 days</td>
              <td className="p-3 bg-yellow-50"><span className="text-yellow-700">45 days</span></td>
              <td className="p-3 bg-red-50"><span className="text-red-700">No requirement</span> <span title="Flagged by AI">⚠️</span></td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Reporting Frequency</td>
              <td className="p-3">Quarterly</td>
              <td className="p-3">Quarterly</td>
              <td className="p-3">Quarterly</td>
              <td className="p-3 bg-yellow-50"><span className="text-yellow-700">Semi-annual</span></td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Termination Notice</td>
              <td className="p-3">90 days</td>
              <td className="p-3">60 days</td>
              <td className="p-3 bg-red-50"><span className="text-red-700">30 days</span></td>
              <td className="p-3">60 days</td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Sublicensing</td>
              <td className="p-3">Not permitted</td>
              <td className="p-3">Not permitted</td>
              <td className="p-3 bg-red-50"><span className="text-red-700">Permitted with approval</span> <span title="Flagged by AI">⚠️</span></td>
              <td className="p-3">Not permitted</td>
            </tr>
            <tr className="border-t">
              <td className="p-3 font-semibold bg-gray-50 sticky left-0">Audit Rights</td>
              <td className="p-3">Annual, 30-day notice</td>
              <td className="p-3">Annual, 30-day notice</td>
              <td className="p-3">Annual, 30-day notice</td>
              <td className="p-3 bg-red-50"><span className="text-red-700">Not specified</span> <span title="Flagged by AI">⚠️</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Legend */}
      <div className="flex gap-6 text-sm text-gray-600">
        <div className="flex items-center gap-2"><div className="w-4 h-4 bg-green-50 border border-green-300 rounded"></div>Favorable / Best terms</div>
        <div className="flex items-center gap-2"><div className="w-4 h-4 bg-yellow-50 border border-yellow-300 rounded"></div>Deviation from standard</div>
        <div className="flex items-center gap-2"><div className="w-4 h-4 bg-red-50 border border-red-300 rounded"></div>Missing / Risky clause</div>
        <div className="flex items-center gap-2">⚠️ Flagged by AI</div>
      </div>
    </div>
  </div></div></div></div></div>
);

export default ContractComparison;
